// Ton bei neuer SMS (Runde 6, Agent 6D, S08): ein kurzer, leiser Zweiklang über die Web-Audio-Schnittstelle (keine Datei). Ob er
// erklingt, steht je Browser in `localStorage` (Standard an); ein Browser ohne Ton oder ohne Erlaubnis bleibt still, ohne Fehler.
const SCHLUESSEL = "crm-sms-ton";

export function tonAn(): boolean {
  try {
    return localStorage.getItem(SCHLUESSEL) !== "aus";
  } catch {
    return true;
  }
}

export function tonSetzen(an: boolean): void {
  try {
    if (an) localStorage.removeItem(SCHLUESSEL);
    else localStorage.setItem(SCHLUESSEL, "aus");
  } catch {
    /* ohne Speicher gilt der Standard */
  }
}

let kontext: AudioContext | null = null;
let zuletzt = 0;

/** Spielt den Ton einmal; mehrere SMS kurz hintereinander ergeben nur einen Ton. `erzwingen` für die Hörprobe. */
export function tonSpielen(erzwingen = false): void {
  if (!erzwingen && !tonAn()) return;
  const jetzt = Date.now();
  if (!erzwingen && jetzt - zuletzt < 2500) return;
  zuletzt = jetzt;
  try {
    const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return;
    kontext = kontext ?? new AC();
    const ctx = kontext;
    if (ctx.state === "suspended") void ctx.resume().catch(() => undefined);
    const start = ctx.currentTime + 0.01;
    [
      [880, 0],
      [1175, 0.14],
    ].forEach(([hz, dt]) => {
      const osz = ctx.createOscillator();
      const pegel = ctx.createGain();
      osz.type = "sine";
      osz.frequency.value = hz;
      pegel.gain.setValueAtTime(0.0001, start + dt);
      pegel.gain.exponentialRampToValueAtTime(0.12, start + dt + 0.02);
      pegel.gain.exponentialRampToValueAtTime(0.0001, start + dt + 0.28);
      osz.connect(pegel).connect(ctx.destination);
      osz.start(start + dt);
      osz.stop(start + dt + 0.3);
    });
  } catch {
    /* Ton ist nie wichtiger als die SMS */
  }
}
